import { VehicleInsuranceRow } from "services/api/calculations/vehicleinsurance/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";


export const CALCULATION_VEHICLE_INSURANCE_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: VehicleInsuranceRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.fromKw.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehicleinsurance.search.fromkw",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.fromKw} kw</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehicleinsurance.search.tokw",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.toKw} kw</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehicleinsurance.search.price",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.price} €</div>
        </div>
      );
    },
  },
];
